import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { defineMessages, FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import _ from 'lodash';

import * as actions from '../../../state';
import { changeBoard } from '../../../events';
import noBoardIcon from './noBoardIcon.png';
import styles from './styles.module.css';

const messages = defineMessages({
  INVALID_BOARD: {
    id: 'INVALID_BOARD',
    defaultMessage: 'You don\'t have permissions to this board',
  },
  NOT_FOUND_BOARD: {
    id: 'NOT_FOUND_BOARD',
    defaultMessage: 'This board cannot be found',
  },
  BACK: {
    id: 'BACK',
    defaultMessage: 'Back',
  },
});

function InvalidBoard() {
  const dispatch = useDispatch();
  const boardList = useSelector((state) => actions.readStateBoardList(state));
  const board = useSelector((state) => actions.readStateBoard(state));

  const renderRedirect = () => {
    if (_.size(boardList) && boardList[0]?.id) {
      dispatch(changeBoard(boardList[0]?.id));
    } else {
      dispatch(changeBoard(''));
    }
  };

  const errNum = board.error || 0;

  return (
    <div style={{ display: 'flex' }}>
      <div className={styles.noBoard}>
        <div>
          <img src={noBoardIcon} alt="logo" className={styles.noIcons} />
          {errNum === 403 && (
            <p className={styles.noBoardMessage}>
              <FormattedMessage {...messages.INVALID_BOARD} />
            </p>
          )}
          {errNum === 404 && (
            <p className={styles.noBoardMessage}>
              <FormattedMessage {...messages.NOT_FOUND_BOARD} />
            </p>
          )}
          <p className={styles.noBoardMessage} />
          <Button variant="contained" color="primary" className={styles.primaryBtn} onClick={renderRedirect}>
            <FormattedMessage {...messages.BACK} />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default InvalidBoard;
